import './main.scss';

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app';
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics';
// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VueObserveVisibility from 'vue-observe-visibility';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Sentry.init({
  dsn: 'https://c0b3d43435804d00853200ebfefb5eb1@sentry.io/1824295',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAp_VAxSaNLu3ABqwuny5PNr_F2uHAuy6M',
  authDomain: 'nosleep-stories.firebaseapp.com',
  databaseURL: 'https://nosleep-stories.firebaseio.com',
  projectId: 'nosleep-stories',
  storageBucket: 'nosleep-stories.appspot.com',
  messagingSenderId: '27221035656',
  appId: '1:27221035656:web:89294f2e79f674df632d3d',
  measurementId: 'G-2L4MT2P8T2'
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

firebase.auth().onAuthStateChanged((user) => {
  const routerView = router.currentRoute.name;
  store.commit('users/setLoggedIn', user && user.uid);

  if (user) {
    firebase.firestore().collection('users')
      .doc(user.uid).get()
      .then((doc) => {
        if (doc.exists) {
          store.commit('setItem', {
            resource: 'users',
            id: user.uid,
            item: doc.data()
          });
        } else {
          store.dispatch('users/createUser', user);
        }

        if ((routerView === 'login') || (routerView === 'register')) {
          router.replace({ name: 'dashboard' });
        }
      })
      .catch((error) => {
        console.log('Error getting document:', error);
      });
  } else if (routerView === 'dashboard') {
    router.replace({ name: 'home' });
  }
});

Vue.config.productionTip = false;

Vue.use(VTooltip);
Vue.use(VueObserveVisibility);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
